import React from "react";
import useMeasure from "utils/hooks/useMeasure";
import styled from "styled-components";

interface AutoSizeInputProps {
  input: React.JSX.Element;
  minWidth?: number;
  value?: number;
}

const AutoSizeInput = ({ input, minWidth, value }: AutoSizeInputProps) => {
  const [measureRef, { width }] = useMeasure<HTMLDivElement>();

  return (
    <>
      <HiddenMeasuringSpan ref={measureRef}>
        {value ?? input.props.value}
      </HiddenMeasuringSpan>
      {React.cloneElement(input, {
        width: width + 8,
        style: { ...input.props.style, minWidth },
      })}
    </>
  );
};

export default AutoSizeInput;

const HiddenMeasuringSpan = styled.span`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  white-space: pre;
`;
